import api from './api';

export const getMyLanguages = (params) => api.get('/v1/my-languages', { params });
export const createMyLanguage = (data) => api.post('/v1/my-languages', data);
export const updateMyLanguage = (id, data) => api.put(`/v1/my-languages/${id}`, data);
export const deleteMyLanguage = (id) => api.delete(`/v1/my-languages/${id}`);

export const getMyEducations = (params) => api.get('/v1/my-educations', { params });
export const createMyEducation = (data) => api.post('/v1/my-educations', data);
export const updateMyEducation = (id, data) => api.put(`/v1/my-educations/${id}`, data);
export const deleteMyEducation = (id) => api.delete(`/v1/my-educations/${id}`);

export const getMyWorkExperiences = (params) => api.get('/v1/my-work-experiences', { params });
export const createMyWorkExperience = (data) => api.post('/v1/my-work-experiences', data);
export const updateMyWorkExperience = (id, data) => api.put(`/v1/my-work-experiences/${id}`, data);
export const deleteMyWorkExperience = (id) => api.delete(`/v1/my-work-experiences/${id}`);

export const getEmployeeResume = (userId) => api.get(`/v1/employee-profile/user/${userId}`);

export const getPendingLanguages = (params) => api.get('/v1/employee-profile/pending/languages', { params });
export const getPendingEducations = (params) => api.get('/v1/employee-profile/pending/educations', { params });
export const getPendingWorkExperiences = (params) => api.get('/v1/employee-profile/pending/work-experiences', { params });
export const getMyPendingResumeApprovals = (params) => api.get('/v1/employee-profile/pending/my-approvals', { params });

export const approveLanguage = (id) => api.put(`/v1/employee-profile/languages/${id}/approve`);
export const rejectLanguage = (id, reason) => api.put(`/v1/employee-profile/languages/${id}/reject`, { reason });
export const approveEducation = (id) => api.put(`/v1/employee-profile/educations/${id}/approve`);
export const rejectEducation = (id, reason) => api.put(`/v1/employee-profile/educations/${id}/reject`, { reason });
export const approveWorkExperience = (id) => api.put(`/v1/employee-profile/work-experiences/${id}/approve`);
export const rejectWorkExperience = (id, reason) => api.put(`/v1/employee-profile/work-experiences/${id}/reject`, { reason });
